import {useUser} from "../../../Context/UserContext";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../../EmptyLine";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultView from "../../V2/ResultView";

export function G2({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}
const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.LB03.error_id: {
            return renderTable(row)
        }
        case MessageCodes.Internal.LB03IB.error_id: {
            return renderTable(row)
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const renderTable = (row) => {
    return (
        <>
            {
                row?.tnm_profiles?.length > 0 && (
                    <ResultText>
                        The library model WSEL table is noted below. The {row?.tnm_profiles?.length} profiles, where the target elevation is not met, are highlighted in red text.
                    </ResultText>
                )
            }
            {
                row?.tnm_profiles?.length === 0 && (
                    <ResultText>
                        The library model WSEL table is noted below.
                    </ResultText>
                )
            }
            <EmptyLine />
            <div style={{width: '99%', overflowX: 'auto'}}>
                <ResultTable style={{width: HecRasHelper.getWidth(12) + (HecRasHelper.getWidth(8) * row?.columns?.length)}}  data={row}>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>River Station</ResultHeaderCell>
                            {
                                row?.columns?.map((c, idx) => (
                                    <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(8), color: row?.tnm_profiles?.find(z => z === idx) ? 'red': ''}}>
                                        {c}
                                    </ResultHeaderCell>
                                ))
                            }
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            row?.data?.map(r => {
                                return (
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'start'}}>{r?.cross_section}</ResultHeaderCell>
                                        {
                                            r?.data.map((x, idx) => (
                                                <ResultBodyCell style={{textAlign: 'right', color: row?.tnm_profiles?.find(z => z === idx) ? 'red': '', width: HecRasHelper.getWidth(8)}}>{x}</ResultBodyCell>
                                            ))
                                        }
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </div>
        </>
    )
}